import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  public Year: string;

  ngOnInit(): void {
    const date = new Date();
    this.Year = date.getFullYear().toString();
  }

}
